export default __webpack_public_path__ + "static/logo_256_vBTC-aedd048b0669605a932029f7160d2022.svg";